import { Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import Input from "@material-ui/core/Input";
import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  bulkEditMarker,
  editMarker,
  omitQuestion,
  translate
} from "../../actions";
import {
  availableLanguageMappingsInverted
} from "../../settings";
import QuestionTabFooter from "./QuestionTabFooter";
import QuestionTabTextField from "./QuestionTabTextField";
import TabPanel from "./TabPanel";

const QuestionTab = ({
  value,
  marker,
  ...rest
}) => {
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  useEffect(() => {
    const f = Object.keys(availableLanguageMappingsInverted)
      .map((lng) => lng)
      .filter((lng) => marker[`question_${lng}`] != null)

    setSelectedLanguages(f);
  }, [marker]);

  return (
    <TabPanel value={value} index={1}>
      {selectedLanguages.map((lng) => (
        <QuestionTabTextField 
          key={lng} 
          disabled 
          marker={marker} 
          defaultValue={lng} 
          textValue={(marker[`question_${lng}`] || "").replaceAll('{', '').replaceAll('}', '')}
          onTextChange={(e) => {
            rest.editMarker({
                key: marker.key,
                text: e.target.value,
                prop: `question_${lng}`,
              })
          }}  
        />
      ))}
      <QuestionTabTextField
        marker={marker}
        value=""
        onChange={(e) => setSelectedLanguages(s => _.union(s, [e.target.value]))} 
        />
      <Divider />
      <Grid item xs={12}>
      <Box mt={2}>
      <Typography variant="h6">
        Answer To Questions Above (all languages, seperate answers with comma)
      </Typography>
      </Box>
      </Grid>
      <Grid item>
      <Box mt={2}>
      <Input
        InputLabelProps={{ shrink: true }}
        fullWidth
        onChange={({ target: { value } }) =>
          rest.editMarker({
            key: marker.key,
            text: value.split(","),
            prop: "answer",
          })
        }
        value={marker.answer || ""}
        label="Answer"
      />
      </Box>
      </Grid>
      <QuestionTabFooter marker={marker} />
    </TabPanel>
  );
};

const mapStateToProps = ({ events }) => {
  const { locations, key, placeholders, translateLoading } = events;
  const marker = locations[key] || {};

  return {
    marker,
    placeholders,
    translateLoading,
  };
};

export default connect(mapStateToProps, {
  bulkEditMarker,
  editMarker,
  translate,
  omitQuestion,
})(QuestionTab);
